export default "__VITE_ASSET__CfdQMO3r__"